// extracted by mini-css-extract-plugin
export default {"privacy":"Privacy_privacy__ua+GE","paragraph":"Privacy_paragraph__PARJ8"};